(() => {
  if (window.ltqrInitialized) return;
  window.ltqrInitialized = true;
  const init = (root = document) => {
    root.querySelectorAll('[data-ltq-company]').forEach((element) => {
      const company = element.dataset.ltqCompany.trim();
      if (!/^[a-zA-Z0-9]+$/.test(company) || document.querySelector('script[src*="static.klaviyo.com/onsite/js/klaviyo.js"]')) return;
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://static.klaviyo.com/onsite/js/klaviyo.js?company_id=' + encodeURIComponent(company);
      document.head.appendChild(script);
    });
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      root.querySelectorAll('.ltq-hero-video video').forEach((video) => {
        video.pause();
        const button = video.parentElement.querySelector('[data-ltq-motion]');
        if (button) button.textContent = button.dataset.play;
      });
    }
  };
  document.addEventListener('click', async (event) => {
    const motion = event.target.closest('[data-ltq-motion]');
    if (motion) {
      const video = motion.parentElement.querySelector('video');
      if (!video) return;
      if (video.paused) {
        try { await video.play(); motion.textContent = motion.dataset.pause; } catch { motion.textContent = motion.dataset.play; }
      } else { video.pause(); motion.textContent = motion.dataset.play; }
    }
    const button = event.target.closest('.ltq-copy-button');
    if (!button) return;
    const feedback = button.nextElementSibling;
    try {
      await navigator.clipboard.writeText(button.dataset.copy || '');
      feedback.textContent = button.dataset.copied;
    } catch { feedback.textContent = button.dataset.copy; }
  });
  document.addEventListener('shopify:section:load', (event) => init(event.target));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
})();

